import appCC from "@/assets/clients/app-cc.svg";
import continenteOnline from "@/assets/clients/cnt.svg";
import siga from "@/assets/clients/siga.svg";
import wells from "@/assets/clients/wells.svg";
import yammi from "@/assets/clients/yammi.svg";
import zu from "@/assets/clients/zu.svg";
import quico from "@/assets/clients/quico.svg";

import Square_appCC from "@/assets/images/app-cc.svg";
import Square_continenteOnline from "@/assets/images/continente-online.svg";
import Square_siga from "@/assets/images/siga.svg";
import Square_wells from "@/assets/clients/wells.svg";
import Square_yammi from "@/assets/images/yammi.svg";
import Square_zu from "@/assets/images/zu.svg";
import Square_quico from "@/assets/images/quico.svg";

export type FooterDisplayMode = "grid" | "carousel" | "none";

export enum FooterAssetKey {
  CartaoContinente = "cartao_continente",
  ContinenteOnline = "continente_online",
  ContinenteSiga = "continente_siga",
  Yammi = "yammi",
  Quico = "quico",
  Wells = "wells_online",
  Zu = "zu",
}

export type FooterAssetItem = {
  key: FooterAssetKey;
  icon: string;
  squareIcon: string;
  altText: string;
  labelI18nKey: string;
};

const CARTAO_CONTINENTE: FooterAssetItem = {
  key: FooterAssetKey.CartaoContinente,
  icon: appCC,
  squareIcon: Square_appCC,
  altText: "Cartão Continente",
  labelI18nKey: "common.cartao_continente",
};
const CONTINENTE_ONLINE: FooterAssetItem = {
  key: FooterAssetKey.ContinenteOnline,
  icon: continenteOnline,
  squareIcon: Square_continenteOnline,
  altText: "Continente Online",
  labelI18nKey: "common.continente_online",
};
const CONTINENTE_SIGA: FooterAssetItem = {
  key: FooterAssetKey.ContinenteSiga,
  icon: siga,
  squareIcon: Square_siga,
  altText: "Continente Siga",
  labelI18nKey: "common.continente_siga",
};
const YAMMI: FooterAssetItem = {
  key: FooterAssetKey.Yammi,
  icon: yammi,
  squareIcon: Square_yammi,
  altText: "Yämmi",
  labelI18nKey: "common.yammi",
};
const QUICO: FooterAssetItem = {
  key: FooterAssetKey.Quico,
  icon: quico,
  squareIcon: Square_quico,
  altText: "Quico Continente",
  labelI18nKey: "common.quico",
};
const WELLS: FooterAssetItem = {
  key: FooterAssetKey.Wells,
  icon: wells,
  squareIcon: Square_wells,
  altText: "Wells",
  labelI18nKey: "common.wells_online",
};
const ZU: FooterAssetItem = {
  key: FooterAssetKey.Zu,
  icon: zu,
  squareIcon: Square_zu,
  altText: "Zu",
  labelI18nKey: "common.zu",
};

export const ASSETS_BY_KEY: Record<FooterAssetKey, FooterAssetItem> = {
  [FooterAssetKey.CartaoContinente]: CARTAO_CONTINENTE,
  [FooterAssetKey.ContinenteOnline]: CONTINENTE_ONLINE,
  [FooterAssetKey.ContinenteSiga]: CONTINENTE_SIGA,
  [FooterAssetKey.Yammi]: YAMMI,
  [FooterAssetKey.Quico]: QUICO,
  [FooterAssetKey.Wells]: WELLS,
  [FooterAssetKey.Zu]: ZU,
};

export const GRID_ASSETS: FooterAssetItem[] = [
  CARTAO_CONTINENTE,
  CONTINENTE_ONLINE,
  CONTINENTE_SIGA,
  YAMMI,
  QUICO,
];

export const CAROUSEL_ASSETS: FooterAssetItem[] = [
  CONTINENTE_ONLINE,
  WELLS,
  ZU,
  CARTAO_CONTINENTE,
  QUICO,
  YAMMI,
  CONTINENTE_SIGA,
];
